export const productDetails = {
  id: 'ID',
  quantity: 'Quantité',
  productDetails: 'Détails d\'emballage',
  specification: 'Détails du produit',
  reviews: 'Avis',
  shipping: 'Livraison',
  share: 'Partager',
  showReviews: 'Afficher les avis',
  noReviews: 'Aucun avis pour le moment',
  quoteReference: {
    quoteContextMsg: 'Ce produit est déjà disponible dans les soumissions suivantes.',
    cartContextMsg: 'Ce produit peut être ajouté avec l\'une des références de soumission suivantes.',
    noContext: 'La référence de soumission sélectionnée sera ajoutée uniquement si vous ajoutez ce produit à un brouillon de commande.',
    removeQtoueReference: 'Supprimer la référence de soumission',
    referenceNotFound: 'Ce produit ne figure dans aucune soumission valide.',
  },
  moq: 'Quantité minimale de commande',
  plantName: 'Nom de l\'usine',
  availableDate: 'Date de disponibilité',
  features: 'Caractéristiques du produit',
  productAvailability: 'Disponibilité du produit',
  leadTime: 'Délai de traitement',
};
export const productList = {
  filterBy: {
    label: 'Filtrer par',
    action: 'Filtrer par',
  },
  appliedFilter: 'Filtre appliqué :',
  showLess: 'Afficher moins...',
  showMore: 'Afficher plus...',
  sortByRelevance: 'Trier par pertinence',
  backToTopBtn: 'Retour en haut',
  showMoreBtn: 'Afficher plus',
  noResults: '0 résultat trouvé.',
  didYouMean: 'Voulez-vous dire :',
  resultsFoundFor: '{{ count }} résultats trouvés pour \'{{ term }}\'.',
  label: {
    id: 'Numéro de code',
    name: 'Nom',
    netPrice: 'Prix net',
    listPrice: 'Liste',
    selectAll: 'Tout sélectionner',
    uom: 'Unité de mesure',
    moq: 'QMC',
    replacewith: 'Remplacé par',
  },
};
export const productFacetNavigation = {
  filterBy: {
    label: 'Filtrer par',
    action: 'Filtrer par',
  },
  appliedFilter: 'Filtre appliqué :',
  showLess: 'Afficher moins...',
  showMore: 'Afficher plus...',
  sortByRelevance: 'Trier par pertinence',
};
export const productSummary = {
  id: 'Numéro de code',
  showReviews: 'Afficher les avis',
  share: 'Partager',
  upc: 'UPC',
  customerMaterial: 'Numéro de matériel client',
};
export const productReview = {
  overallRating: 'Évaluation globale',
  reviewTitle: 'Titre de l\'avis',
  writeYourComments: 'Rédigez vos commentaires',
  rating: 'Évaluation',
  reviewerName: 'Nom du réviseur (facultatif)',
  writeReview: 'Rédiger un avis',
  more: 'Plus',
  less: 'Moins',
  thankYouForReview: 'Merci pour votre avis! Notez que les avis peuvent nécessiter une vérification avant d\'apparaître ici.',
};
export const addToCart = {
  itemsAddedToYourCart: 'Article(s) ajouté(s) à votre panier',
  itemsIncrementedInYourCart: 'Cet article était déjà dans votre panier. La quantité a été mise à jour.',
  items: 'Articles',
  updatingCart: 'Mise à jour du panier...',
  addToCart: 'Ajouter au brouillon de commande',
  viewCart: 'Voir le panier',
  proceedToCheckout: 'Passer à la caisse',
  quantity: 'Qté',
  outOfStock: 'En rupture de stock',
  inStock: 'En stock',
  selectStyleAndSize: 'Sélectionnez le style et la taille pour vérifier le stock',
};
export const TabPanelContainer = {
  tabs: {
    ProductDetailsTabComponent: 'Détails d\'emballage',
    ProductSpecsTabComponent: 'Détails du produit',
    ProductReviewsTabComponent: 'Avis',
    deliveryTab: 'Livraison',
    ProductCertificationsTabComponent: 'Certifications du produit',
    ProductTechnicalDocumentsTabComponent: 'Documents techniques',
  },
};
export const variant = {
  style: 'Style',
  selectedStyle: 'Style sélectionné',
  size: 'Taille',
  color: 'Couleur',
  sizeGuideLabel: 'Guide des styles',
};
export const addToWishList = {
  add: 'Ajouter à la liste de souhaits',
  remove: 'Retirer de la liste de souhaits',
  anonymous: 'Connectez-vous pour ajouter à la liste de souhaits',
};
export const stockNotification = {
  notifyMe: 'M\'aviser',
  stopNotify: 'Arrêter les notifications',
  getNotify: 'Recevez un avis lorsque ce produit est disponible.',
  getNotifySuffix: 'pour être avisé lorsque ce produit est disponible.',
  activateChannelsPrefix: 'Pour être avisé, vous devez activer les ',
  channelsLink: 'Canaux de notification',
  activateChannelsSuffix: '.',
  notified: 'Vous serez avisé lorsque ce produit sera de nouveau en stock.',
  getNotified: 'Recevez un avis lorsque ce produit est de nouveau en stock.',
  unsubscribeSuccess: 'Vous ne recevrez plus de notification de retour en stock pour ce produit.',
  subscriptionDialog: {
    header: 'Abonnement aux ruptures de stock',
    notifiedPrefix: 'Vous serez avisé à :',
    notifiedSuffix: 'dès que ce produit sera de nouveau en stock.',
    manageChannelsPrefix: 'Gérez vos canaux de notification préférés sur la page ',
    manageChannelsLink: 'Préférences de notification',
    manageChannelsSuffix: '.',
    manageSubscriptionsPrefix: 'Vous pouvez gérer vos abonnements sur la page ',
    manageSubscriptionsLink: 'Mes intérêts',
    manageSubscriptionsSuffix: '.',
    okBtn: 'OK',
    subscribing: 'Inscription aux notifications de rupture de stock pour ce produit',
  },
};

export const KnBrCMSTabParagraphContainer = {
  tabs: {
    ProductDetailsTabComponent: 'Détails du produit',
    ProductSpecsTabComponent: 'Spécifications',
    ProductReviewsTabComponent: 'Avis',
    deliveryTab: 'Livraison',
    ProductCertificationsTabComponent: 'Certifications du produit',
  },
};

export const knBrSearchBox = {
  minCharWarning: 'Veuillez saisir au moins 3 caractères pour effectuer une recherche.',
  emptySearchWarning: 'Veuillez entrer des critères de recherche.',
};

export const knbrProduct = {
  stockNotification,
  addToWishList,
  variant,
  TabPanelContainer,
  addToCart,
  productReview,
  productSummary,
  productFacetNavigation,
  productList,
  productDetails,
  KnBrCMSTabParagraphContainer,
  knBrSearchBox,
};
